<script setup>
import { computed } from 'vue';
import { useMessageContext } from '../../provider.js';
import { useMapGetter } from 'dashboard/composables/store';
import { INBOX_TYPES } from 'dashboard/helper/inbox';

import MessageFormatter from 'shared/helpers/MessageFormatter.js';
import { MESSAGE_VARIANTS } from '../../constants';

const props = defineProps({
  content: {
    type: String,
    required: true,
  },
});

const { variant, inboxId } = useMessageContext();
const getInbox = useMapGetter('inboxes/getInbox');

// SuperTVGo: a bolha mostra o que o CLIENTE vai ver no WhatsApp de verdade —
// asterisco vira negrito (não itálico), sem lista (WhatsApp não tem essa
// sintaxe). Só pra Channel::Api; qualquer outro canal renderiza como sempre
// renderizou.
const isWhatsAppChannel = computed(
  () => getInbox.value(inboxId.value)?.channel_type === INBOX_TYPES.API
);

const formattedContent = computed(() => {
  if (variant.value === MESSAGE_VARIANTS.ACTIVITY) {
    return props.content;
  }

  return new MessageFormatter(
    props.content,
    false,
    false,
    true,
    isWhatsAppChannel.value
  ).formattedMessage;
});
</script>

<template>
  <div v-dompurify-html="formattedContent" class="prose prose-bubble" />
</template>
